<template>
    <div class="user-token">
        <template v-if="userPermission == 1">
            <lgn-input class="user-token-search" placeholder="搜尋" v-model="searchText" 
            :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchTokens"
            @keyup.enter.native="searchTokens"></lgn-input>
            <div class="user-token-info">
                <span class="user-token-info-label">總數量：</span>
                <span class="user-token-info-value">{{tokenLength}}</span>
                <button type="button" @click="openAddedTokenDialog()" class="user-token-info-add-button el-icon-circle-plus"></button>
            </div>
            <div class="paca-table">
                <div class="paca-table__header">
                    <div class="paca-table__header-item item-column column-edit"></div>
                    <div class="paca-table__header-item item-column column-name">{{$t("table.header.name")}} ({{tokenList.length}})</div>
                    <div class="paca-table__header-item item-column column-vehicle">{{$t("table.header.vehicle")}}</div>
                    <div class="paca-table__header-item item-column column-gate">{{$t("table.header.gate")}}</div>
                    <div class="paca-table__header-item item-column column-accounting">{{$t("table.header.accounting")}}</div>
                    <div class="paca-table__header-item item-column column-action"></div>
                </div>
                <div class="paca-table__body" v-if="viewTokenList.length != 0">
                    <div class="paca-table__body-col" v-for="(item, index) in viewTokenList" :key="index">
                        <div class="paca-table__body-col-list">
                            <div class="paca-table__body-col-list-item item-column column-edit">
                                <button type="button" class="column-edit-icon el-icon-edit" @click="openAddedTokenDialog(item)"></button>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-name">
                                <span class="column-name-text">{{item.token_name}}</span>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-vehicle">
                                <button class="item-column-checkbox checkbox-button" :class="{'is-check': item.priv_car_edit == 1}" @click="updateToken(item, 'priv_car_edit', item.priv_car_edit)"></button>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-gate">
                                <button class="item-column-checkbox checkbox-button" :class="{'is-check': item.priv_gate == 1 }" @click="updateToken(item, 'priv_gate', item.priv_gate)"></button>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-accounting">
                                <button class="item-column-checkbox checkbox-button" :class="{'is-check': item.priv_accounting == 1}" @click="updateToken(item, 'priv_accounting', item.priv_accounting)"></button>
                            </div>
                            <div class="paca-table__body-col-list-item item-column column-action">
                                <button type="button" class="column-action-icon el-icon-delete" @click="deleteServiceToken(item.token_name, item.token_id, index)"></button>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="tokenListIteration()">更多</button>
                </div>
                <div class="paca-table__empty" v-else></div>
            </div>
        </template>
        <template v-else-if="userPermission == 0">
            <div class="user-token-description">
                <div class="user-token-description-item">
                    <p class="user-token-description-item-title">什麼是憑證管理</p>
                    <p class="user-token-description-item-content">
                        憑證管理服務是針對 SmartPark 停管系統用戶所設計的功能，透過
                         <a href="https://www.paca.com.tw/pub/doc/api/smartpark/v1" target="_blank">SmartPark API</a> 
                        與現場停管系統整合串接。
                    </p>
                    <p class="user-token-description-item-content">
                        使用者只要加入各場站的憑證項目，就可以同時管理、編輯、數百個場站的憑證。
                    </p>
                </div>
                <div class="user-token-description-item">
                    <p class="user-token-description-item-title">如何取得憑證管理權限</p>
                    <p class="user-token-description-item-content">為確保資料使用之安全性，憑證管理服務需要核對會員身分。</p>
                    <p class="user-token-description-item-content">
                        請 Email:
                         <a href="mailto:service@berryan.com" target="_blank">service@berryan.com</a> 
                        提供您的註冊帳號、公司名稱，或代管場站名稱，我們將為您開啟此功能。
                    </p>
                </div>
            </div>
        </template>
        <template v-else-if="userPermission == -1"></template>
        
        <el-dialog class="user-token-edit-dialog" :visible.sync="isEditToken">
            <div slot="title">
                {{sourceTokenId ? '編輯項目' : '新增項目'}}
            </div>
            <div class="user-token-edit-dialog__body">
                <lgn-form-item label-position="left" class="user-token-edit-dialog__body-item">
                    <div slot="label" class="user-token-edit-dialog__body-item-label">名稱</div>
                    <lgn-input slot="input" type="text" v-model="sourceToken.token_name"></lgn-input>
                </lgn-form-item>
                <div class="user-token-edit-dialog__body-item">
                    <el-checkbox class="user-token-edit-dialog__body-item-checkbox" v-model="checkMultName">請避免使用重複的名稱, 以免混淆!</el-checkbox>
                </div>
            </div>
            <div class="user-token-edit-dialog__footer" slot="footer">
                <button type="button" class="user-token-edit-dialog__footer-button second-button" @click="closeEditTokenDialog">取消</button>
                <button type="button" class="user-token-edit-dialog__footer-button main-button" :disabled="!checkMultName" @click="submitEditToken">送出</button>
            </div>
        </el-dialog>
        <el-dialog class="user-token-api-token" :visible.sync="isTokenGet">
            <div slot="title">權限代碼</div>
            <div class="user-token-api-token__body">
                <div class="user-token-api-token__body-info">
                    <div class="user-token-api-token__body-info-left">僅顯示此一次 API TOKEN，請妥善保管</div>
                    <button class="user-token-api-token__body-info-right el-icon-document-copy" @click="copyApiToken()"></button>
                </div>
                <div class="user-token-api-token__body-token" tabindex="-1">{{apiToken}}</div>
            </div>
            <div class="user-token-api-token__footer" slot="footer">
                <button type="button" class="user-token-api-token__footer-button main-button" @click="closeApiTokenDialog">確認</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
export default {
    name: "userToken",
    data(){
        return {
            searchText: '',
            tokenPermission: {},
            tokenList: [],
            viewTokenList: [],
            tokenLength: 0,
            tableLoading: false,
            isEditToken: false,
            sourceToken: {},
            sourceTokenId: null,
            isTokenGet: false,
            apiToken: '',
            checkMultName: false,
            viewMoreCount: 0,
            isShowMoreButton: true,
            userPermission: -1
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async getServiceTokenList(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            this.viewTokenList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            let res =  await api.getServiceToken();
            if(!res.error_status){
                setTimeout(function(){
                    this.tokenPermission = res.permission_list;
                    res.token_list.forEach((list) => {
                        list.token_permission.forEach((token) => {
                            if(token.name === "LOCK"){
                                list.is_lock = 1;
                            } else if(token.name !== "TOKEN"){
                                list[token.name] = 1;
                            }
                        })
                    })
                    this.tableLoading = false;
                    setTimeout(function(){
                        this.$nextTick(() => {
                            this.pageLoading(false);
                            this.userPermission = 1;
                            this.tokenList = res.token_list;
                            this.tokenLength = this.tokenList.length;
                            this.tokenListIteration();
                        })
                    }.bind(this), 300);
                }.bind(this), 300);
                
            }else if(res.error_status == '403'){
                this.pageLoading(false);
                this.userPermission = 0;
            }else if(res.error_status != '401' && res.error_status != '504'){
                this.pageLoading(false);
                this.userPermission = 0;
                this.$message.error({
                    duration: '2500',
                    showClose: true,
                    message: "發生錯誤"
                })
            }
        },
        async searchTokens(){
            if(this.searchText.trim().length != 0){
                let data = {
                    search: this.searchText
                }
                this.viewMoreCount = 0;
                this.isShowMoreButton = true;
                this.viewTokenList = [];
                this.$nextTick(() => {
                    this.tableLoading = true;
                })
                let res = await api.postServiceTokenSearch(data);
                if(!res.error_status){
                    setTimeout(function(){
                        this.tokenPermission = res.permission_list;
                        res.token_list.forEach((list) => {
                            list.token_permission.forEach((token) => {
                                if(token.name === "LOCK"){
                                    list.is_lock = 1;
                                } else if(token.name !== "TOKEN"){
                                    list[token.name] = 1;
                                }
                            })
                        })
                        this.tableLoading = false;
                        setTimeout(function(){
                            this.$nextTick(() => {
                                this.tokenList = res.token_list;
                                this.tokenListIteration();
                            })
                        }.bind(this), 300);
                    }.bind(this), 300);
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤"
                    })
                }
            }else{
                this.getServiceTokenList();
            }
        },
        tokenListIteration(){
            if((this.viewMoreCount + 1)*30 >= this.tokenList.length){
                this.isShowMoreButton = false;
            }
            this.viewTokenList = this.viewTokenList.concat(this.tokenList.slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        openAddedTokenDialog(editingToken){
            this.isEditToken = true;
            this.checkMultName = false;
            if(editingToken){
                this.sourceTokenId = editingToken.token_id;
                this.sourceToken = {
                    token_name: editingToken.token_name,
                    token_permission: [],
                },
                Object.keys(this.tokenPermission).forEach(function(item){
                    if(editingToken[item]){
                        this.sourceToken.token_permission.push({
                            name: item,
                            enable: 1
                        })
                    } else{
                        this.sourceToken.token_permission.push({
                            name: item,
                            enable: 0
                        })
                    }
                }.bind(this));
            }else{
                this.sourceTokenId = null;
                this.sourceToken = {
                    token_name: '',
                    token_permission: [],
                };
                Object.keys(this.tokenPermission).forEach(function(item){
                    this.sourceToken.token_permission.push({
                        name: item,
                        enable: 0
                    })
                }.bind(this));
            }
        },
        sourceCheckboxModel(permission){
            let res = this.sourceToken.token_permission.find(item => item.name == permission);
            res = res.enable == 1 ? true : false;
            return res;
        },
        closeEditTokenDialog(){
            this.isEditToken = false;
        },
        submitEditToken(){
            if(this.sourceTokenId){
                this.updateToken();
            }else{
                this.postTokenCreate();
            }
        },
        async postTokenCreate(){
            if(this.sourceToken.token_name.trim().length != 0){
                let res = await api.postServiceTokenCreate(this.sourceToken);
                if(!res.error_status){
                    setTimeout(function(){
                        this.openApiTokenDialog(res.token.api_token);
                    }.bind(this), 500);
                }else if(res.error_status == '403'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "該用戶無此服務，如有需要請聯絡管理員!"
                    })
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "發生錯誤!"
                    })
                }
                this.isEditToken = false;
                await this.getServiceTokenList();
                this.tokenLength = this.tokenList.length;
            }else {
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請輸入名稱!"
                })
            }
            
        },
        async updateToken(editingToken, key, value){
            if(!editingToken){
                let res = await api.putServiceToken(this.sourceTokenId, this.sourceToken);
                if(!res.error_status){
                    this.tokenList.find(item => item.token_id == this.sourceTokenId).token_name = this.sourceToken.token_name;
                }else if(res.error_status == '403'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "該用戶無此服務，如有需要請聯絡管理員!"
                    })
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "發生錯誤!"
                    })
                }
                this.isEditToken = false;
            }else{
                value = value && value == 1 ? 1 : 0;
                this.sourceTokenId = editingToken.token_id;
                this.sourceToken = {
                    token_name: editingToken.token_name,
                    token_permission: []
                },
                Object.keys(this.tokenPermission).forEach(function(item){
                    if(item == key){
                        this.sourceToken.token_permission.push({
                            name: item,
                            enable: ((value + 1) % 2)
                        })
                    } else if(editingToken[item]){
                        this.sourceToken.token_permission.push({
                            name: item,
                            enable: 1
                        })
                    }else{
                        this.sourceToken.token_permission.push({
                            name: item,
                            enable: 0
                        })
                    }
                }.bind(this));
                let res = await api.putServiceToken(this.sourceTokenId, this.sourceToken);
                if(!res.error_status){
                    let changeItem = this.tokenList.find(item => item.token_id == this.sourceTokenId);
                    if(!changeItem[key]){
                        this.$set(changeItem, key, 0);
                    }
                    changeItem[key] = (value + 1) % 2;
                }else if(res.error_status == '403'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "該用戶無此服務，如有需要請聯絡管理員!"
                    })
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "發生錯誤!"
                    })
                }
                this.isEditToken = false;
            }
        },
        async deleteServiceToken(token_name, token_id, index){
            this.$confirm(`即將刪除 ${token_name}`,"刪除權限", {
                confirmButtonText: "確認刪除",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let res = await api.deleteServiceToken(token_id);
                if(!res.error_status){
                    this.tokenList.splice(index,1);
                    this.viewTokenList.splice(index,1);
                    this.tokenLength -= 1;
                }else if(res.error_status == '403'){
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: "該用戶無此服務，如有需要請聯絡管理員!"
                    })
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        },
        openApiTokenDialog(token){
            this.apiToken = token;
            this.isTokenGet = true;
        },
        copyApiToken(){
            let node = document.querySelector('.user-token-api-token__body-token');
            let range = null;
            if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(node);
                range.select();
                document.execCommand("copy");
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: '複製成功'
                })
                alert("複製成功!");
            } else if (window.getSelection) {
                var selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(node);
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand("copy");
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: '複製成功'
                })
            } else {
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: '無法複製內容、瀏覽器不支援'
                })     
            }
        },
        closeApiTokenDialog(){
            this.apiToken = '';
            this.isTokenGet = false;
        },
        pageLoading(value){
            let loadingStyle = "full-height";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.user-token',
                    text: '讀取中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        }
    },
    async activated(){
        this.userPermission = -1;
        this.pageLoading(true);
        await this.getServiceTokenList();
    },
    watch: {
        tableLoading(value){
            if(document.querySelector('user-token-search')){
                let hasData = document.querySelector(".paca-table__body");
                let loadingStyle = "";
                let asideWidth = document.querySelector(".el-aside").offsetWidth;
                if(hasData){
                    loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
                }
                if(asideWidth > 150){
                    loadingStyle += " collapse-open";
                }else if(asideWidth > 50){
                    loadingStyle += " collapse-exist";
                }
                if(value == true){
                    this.loadingMethod = this.$loading({
                        lock: true,
                        target: '.paca-table__empty',
                        text: '搜尋中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255,255,255,0.8)',
                        customClass: loadingStyle
                    });
                }else{
                    if(this.loadingMethod != null){
                        this.loadingMethod.close();
                    }
                }
            }
        }
    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo
        }
    }
}
</script>